var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
function normalizeValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value + '';
}
class InputSearch extends React.Component {
    constructor(props) {
        super(props);
        this.focus = () => {
            if (this.inputRef) {
                this.inputRef.focus();
            }
        };
        this.onInputChange = (event) => {
            const { onChange, disabled } = this.props;
            if (disabled)
                return;
            const value = normalizeValue(event.target.value);
            onChange && onChange(value);
        };
        this.onInputFocus = (event) => {
            const { onFocus, disabled } = this.props;
            if (disabled)
                return;
            const value = normalizeValue(event.target.value);
            onFocus && onFocus(value);
        };
        this.onInputBlur = (event) => {
            const { onBlur, disabled } = this.props;
            if (disabled)
                return;
            const value = normalizeValue(event.target.value);
            onBlur && onBlur(value);
        };
        this.handleCancel = () => {
            const { onCancel } = this.props;
            onCancel && onCancel();
        };
        this.onInputClear = () => {
            const { onChange } = this.props;
            onChange && onChange('');
        };
        this.popInputRef = (el) => {
            const { autoFocus } = this.props;
            this.inputRef = el;
            autoFocus && this.focus();
        };
        this.state = {
            value: normalizeValue(props.value || props.defaultValue),
        };
    }
    static getDerivedStateFromProps(nextProps) {
        if (nextProps.value !== undefined) {
            return {
                value: normalizeValue(nextProps.value),
            };
        }
        return null;
    }
    render() {
        const _a = this.props, { showSearchIcon, cancelBtn, placeholder, style, clearable, maxLength, defaultValue, disabled, className } = _a, restProps = __rest(_a, ["showSearchIcon", "cancelBtn", "placeholder", "style", "clearable", "maxLength", "defaultValue", "disabled", "className"]);
        const { value } = this.state;
        const searchCls = classnames('cfm_input_search', {
            'cfm_input_search_disabled': disabled,
        }, className);
        return (<div style={style} className={searchCls}>
        <div onClick={this.focus} className='cfm_search_control'>
          {showSearchIcon ? <Icon className='cfm_search_input_icon' size='sm' type='search'/> : null}
          <input {...restProps} ref={this.popInputRef} className='cfm_search_input_inner' onChange={this.onInputChange} value={normalizeValue(value)} defaultValue={undefined} disabled={disabled} maxLength={maxLength} placeholder={placeholder} onFocus={this.onInputFocus} onBlur={this.onInputBlur} autoComplete='off'/>
          {clearable && !!value && !disabled
            ? <div className='cfm_search_clear' onClick={this.onInputClear}>
                <Icon size='sm' type='close_2'/>
              </div>
            : null}
        </div>
        {cancelBtn
            ? <div onClick={this.handleCancel} className='cfm_search_cancel'>{cancelBtn}</div> : null}
      </div>);
    }
}
InputSearch.defaultProps = {
    defaultValue: '',
    placeholder: '',
    disabled: false,
    clearable: true,
    autoFocus: false,
    showSearchIcon: true,
};
export default InputSearch;



// WEBPACK FOOTER //
// ./components/input-search/index.tsx